import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder } from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { Observable, throwError } from 'rxjs';
import { map, retry, catchError } from 'rxjs/operators';
import { RtvGpsLocation } from '@bds/railtrac-models';

@Injectable({
    providedIn: 'root',
})
export class RtGpsLocationService {
    private readonly baseUrl: string;
    private readonly odataUrl: string;

    constructor(
        private http: HttpClient,
        private fb: UntypedFormBuilder,
        @Inject('BASE_API_URL') private apibaseUrl: string,
        @Inject('BASE_ODATA_URL') private odatabaseUrl: string,
    ) {
        this.baseUrl = this.apibaseUrl;
        this.odataUrl = this.odatabaseUrl;
    }

    getODataStore(): DataSource {
        return new DataSource({
            store: new ODataStore({
                version: 4,
                url: this.odataUrl + 'gpsLocation',
            }),
            paginate: true,
            pageSize: 20,
        });
    }

    getHistoryGpsViaOdata(gpsLocation: RtvGpsLocation): Observable<RtvGpsLocation[]> {
        let filter = `(assetGpsId eq '${gpsLocation?.assetGpsId.trim()}') and (gpsLocationType eq 'H')`;

        return this.http
            .get<{ value: RtvGpsLocation[] }>(
                `${this.odataUrl}gpsLocation?$filter=${filter}&$select=carInit,carNo,assetGpsId,longitude,latitude, gpsLocationType&$apply=groupby((carInit,carNo,assetGpsId,longitude,latitude,gpsLocationType))`,
            )
            .pipe(
                map((data: { value: RtvGpsLocation[] }) => data.value ?? []),
                retry(1),
                catchError((error) => {
                    console.error('Error fetching GPS history:', error);
                    return throwError(() => error);
                }),
            );
    }
}
